import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'carManageController';
export default {
    /**
     * 车库管理查询列表
     */
    getAllGarages: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getAllGarages',
        type: requestType.Get,
    },
    /**
     * 新增车库
     */
    addGarage: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'addGarage',
        type: requestType.Post
    },
    /**
     * 修改车库
     */
    updateGarage: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'updateGarage',
        type: requestType.Put
    },
    /**
     * 库存车辆列表
     */
    getAllWarehouseCar: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getAllWarehouseCar',
        type: requestType.Get
    },
    /**
     * 全部车库列表
     */
    getAllGaragesList: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getAllGaragesList',
        type: requestType.Get
    },
    /**
     * 车库下的库管员
     */
    getGarageUsersById: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getGarageUsersById',
        type: requestType.Get
    },
    /**
     * 入库申请
     */
    updateWarehouseCar: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'updateWarehouseCar',
        type: requestType.Post
    },
    /**
     * 车辆审批列表
     */
    getAllWarehouseApproval: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getAllWarehouseApproval',
        type: requestType.Get
    },
    /**
     * 获取当前案件的库存车辆信息
     */
    getWarehouseCarByCaseInfoRecordId: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getWarehouseCarByCaseInfoRecordId',
        type: requestType.Get
    },
    /**
     * 变更归属信息
     */
    updateApplyUserInfo: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'updateApplyUserInfo',
        type: requestType.Post
    },
    /**
     * 出入库审核
     */
    warehouseApproval: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'warehouseApproval',
        type: requestType.Post
    },
    /**
     * 入库报表
     */
    getWarehouseCarReport: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getWarehouseCarReport',
        type: requestType.Get
    },
    /**
     * 入库车辆报表导出
     */
    warehouseCarReportExport: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'warehouseCarReportExport',
        type: requestType.Get
    },
    /**
     * 库管审批导出
     */
    warehouseApprovalExport: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'warehouseApprovalExport',
        type: requestType.Get
    }
};
